import { createBrowserRouter } from "react-router-dom";
import Home from "../Home/Home/Home";
import ProjectDetails from "../Home/Projects/ProjectDetails";
import Main from "../Layout/Main";


const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/projectDetails/:id',
                element: <ProjectDetails></ProjectDetails>,
                loader: ({ params }) => fetch(`https://portfolio-server-silk.vercel.app/projects/${params.id}`)
            }
        ]
    }
])

export default router;
